{
  "Accessibility Menu": "Menu prístupnosti",
  "Reset settings": "Obnoviť nastavenia",
  "Close": "Zavrieť",
  "Content Adjustments": "Nastavenia obsahu",
  "Adjust Font Size": "Prispôsobiť veľkosť písma",
  "Highlight Title": "Zvýrazniť nadpis",
  "Highlight Links": "Zvýrazniť odkazy",
  "Readable Font": "Čitateľné písmo",
  "Color Adjustments": "Nastavenia farieb",
  "Dark Contrast": "Tmavý kontrast",
  "Light Contrast": "Svetlý kontrast",
  "High Contrast": "Vysoký kontrast",
  "High Saturation": "Vysoká saturácia",
  "Low Saturation": "Nízka saturácia",
  "Monochrome": "Monochromatické",
  "Contrast": "Kontrast",
  "Invert Colors": "Invertovať farby",
  "Tools": "Nástroje",
  "Reading Guide": "Sprievodca čítaním",
  "Stop Animations": "Zastaviť animácie",
  "Big Cursor": "Veľký kurzor",
  "Increase Font Size": "Zväčšiť veľkosť písma",
  "Decrease Font Size": "Zmenšiť veľkosť písma",
  "Letter Spacing": "Rozostup písmen",
  "Line Height": "Výška riadku",
  "Font Weight": "Tlak písma",
  "Dyslexia Font": "Písmo pre dyslexiu",
  "Language": "Jazyk",
  "Open Accessibility Menu": "Otvoriť menu prístupnosti",
  "Widget Settings": "Nastavenia widgetu",
  "Widget Position": "Pozícia widgetu",
  "Top Left": "Hore vľavo",
  "Top Center": "Hore v strede",
  "Top Right": "Hore vpravo",
  "Center Left": "V strede vľavo",
  "Center Right": "V strede vpravo",
  "Bottom Left": "Dole vľavo",
  "Bottom Center": "Dole v strede",
  "Bottom Right": "Dole vpravo",
  "Screen Reader": "Čítačka obrazovky",
  "Voice Navigation": "Hlasová navigácia",
  "Custom Color": "Vlastná farba",
  "Change the site's colors": "Zmeňte farby webu",
  "Backgrounds": "Pozadia",
  "Headings": "Nadpisy",
  "Contents": "Obsahy",
  "Reset colors": "Resetovať farby",
  "Image Desaturation": "Desaturácia obrázka",
  "Search languages": "Hľadať jazyky",
  "No languages found": "Žiadne jazyky sa nenašli",
  "Accessibility Profiles": "Profily prístupnosti",
  "Motor Impaired": "Motorické obmedzenie",
  "Big cursor, voice navigation, and no animations.": "Veľký kurzor, hlasová navigácia a žiadne animácie.",
  "Blind": "Nevidiaci",
  "Screen reader helpers with higher contrast.": "Pomocníci pre čítačku obrazovky s vyšším kontrastom.",
  "Color Blind": "Farbosleposť",
  "High contrast palette with desaturated media.": "Paleta s vysokým kontrastom a zníženou saturáciou médií.",
  "Dyslexia": "Dyslexia",
  "Friendly font, extra spacing, stronger weight.": "Priateľské písmo, väčšie rozostupy a silnejšie znaky.",
  "Low vision": "Slabozrakosť",
  "Dark contrast and 130% magnification.": "Tmavý kontrast a zväčšenie 130 %.",
  "Cognitive & Learning": "Kognitívne a učenie",
  "Highlights key sections and enables voice help.": "Zvýrazní kľúčové sekcie a zapne hlasovú pomoc.",
  "Seizure & Epileptic": "Záchvaty a epilepsia",
  "Stops animations and desaturates imagery.": "Zastaví animácie a zníži sýtosť obrázkov.",
  "ADHD": "ADHD",
  "Reading guide, highlighted links, calmer palette.": "Sprievodca čítaním, zvýraznené odkazy a pokojnejšia paleta.",
  "Widget Size": "Widget Size",
  "Default": "Default",
  "Medium": "Medium",
  "Small": "Small",
  "Color Blindness": "Color Blindness",
  "Protanopia": "Protanopia",
  "Deuteranopia": "Deuteranopia",
  "Tritanopia": "Tritanopia",
  "Achromatopsia": "Achromatopsia",
  "Simulates and assists users with color vision deficiencies.": "Simulates and assists users with color vision deficiencies."
}
